import { RegulatedCompanyRowTypes } from './types';

import cn from './styles.module.css';

const RegulatedCompanyRow = ({
  title,
  children,
  annualIncome,
  textarea,
  accountsCurrencies,
  withoutPadding,
}: RegulatedCompanyRowTypes) => (
  <div
    className={`${cn.regulatedCompanyQuestionnarieRow} ${withoutPadding ? cn.withoutPadding : ''} ${accountsCurrencies ? cn.accountsCurrencies : ''} ${annualIncome ? cn.annualIncome : ''} ${textarea ? cn.textarea : ''}`}
  >
    <div className={cn.regulatedCompanyQuestionnarieTitle}>{title}</div>
    <div className={cn.regulatedCompanyQuestionnarieValue}>{children}</div>
  </div>
);

export default RegulatedCompanyRow;
